// @NOTE: assumes jQuery is included by WP
const $ = jQuery

import Isotope from "isotope-layout";
import Swiper from 'swiper/bundle';
// import IsotopeFitColumns from "isotope-fit-columns";

class gallery {
  constructor () {
    this.$body = $('body')
    this.isGalleryTemplate = this.$body.hasClass('page-template-template-gallery')

    if (!this.isGalleryTemplate) {
      return
    }

    this.isotopeGallery                = null
    this.$galleryContainer             = $('.gallery-container')
    this.$categoryFilterTriggers       = $('[data-trigger-filter]')
    this.$gridItems                    = $('.grid-item')
    this.$carouselModal                = $('#carousel-modal')
    this.$carouselCurtain              = $('#carousel-modal .curtain')
    this.$carouselContainer            = $('#carousel-container')
    this.clickedItemsIndex             = null
    this.swiper                        = null
    this.$slideCurtains                = null
    this.$slideImagesWithExternalLinks = null

    this.initIsotope()
    this.initFilter()
    
    this.$gridItems.click((event) => {
      const $element            = $(event.currentTarget)
      const externalLink        = $element.attr('data-external-link')

      if (externalLink) {
        window.open(externalLink, '_blank')
        return
      }

      const elementAttachmentId = $element.attr('data-attachment-id')
      const filteredElements    = this.isotopeGallery.getFilteredItemElements()
      const allAttachmentIds    = this.getAllAttachmentIDs(filteredElements)
      this.clickedItemsIndex    = allAttachmentIds.indexOf(elementAttachmentId)

      this.getCarouselViaAjax(allAttachmentIds)
    })

    this.$carouselCurtain.click((event) => {
      this.deactivateModal()
    })
  }

  fadeGridItemsInOneByOne () {
    const numberOfGridItems = this.$gridItems.length
    let loopIndex = 0
    window.loadAnimationInterval = setInterval(() => {
      if (loopIndex >= numberOfGridItems - 1) {
        clearInterval(window.loadAnimationInterval)

        // need to remove transition css so isotope works correctly
        this.$gridItems.removeClass('force-transition')
      }
      this.$gridItems.eq(loopIndex).removeClass('pre-load-animation')

      loopIndex++
    }, 50)
  }

  onWindowLoad () {
    this.fadeGridItemsInOneByOne()
  }

  getCarouselViaAjax (allAttachmentIds) {
    this.setLoadingState()

    $.ajax({
			type: 'POST',
			url: window.ajaxUrl,
			data: {
				action: 'the_district_get_carousel',
        attachment_ids: allAttachmentIds
			}
		}).always((response) => {
      this.unSetLoadingState()
		}).success((response) => {
      this.activateCarouselModal(response)
		}).fail((response) => {
			console.log('carousel call failed')
		});
  }

  setLoadingState () {
    this.$galleryContainer.addClass('is-loading')
  }

  unSetLoadingState () {
    this.$galleryContainer.removeClass('is-loading')
  }

  activateCarouselModal (carouselHTML) {
    this.$carouselContainer.html(carouselHTML)
    this.$carouselModal.addClass('active')

    this.swiper = new Swiper('#carousel-container .swiper', {
      loop: true,
      centeredSlides: true,
      keyboard: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }
    });

    this.swiper.slideTo(this.clickedItemsIndex + 1, 0)

    this.$slideImagesWithExternalLinks = $('#carousel-container .swiper .swiper-slide[data-external-link] img')
    this.$slideCurtains                = $('#carousel-container .swiper .swiper-slide .slide-curtain')

    this.$slideImagesWithExternalLinks.click((event) => {
      const $elementsParent = $(event.currentTarget).parent()
      const externalLink    = $elementsParent.attr('data-external-link')

      if (externalLink) {
        window.open(externalLink, '_blank')
      }
    })

    this.$slideCurtains.click((event) => {
      this.deactivateModal()
    })
  }

  deactivateModal () {
    this.$carouselModal.removeClass('active')
  }

  getAllAttachmentIDs (filteredElements) {
    return filteredElements.map((element) => {
      return $(element).attr('data-attachment-id')
    })
  }

  initFilter () {
    this.$categoryFilterTriggers.click((event) => {
      const $element   = $(event.currentTarget)
      const filterTerm = $element.attr('data-trigger-filter')

      if (filterTerm == 'all') {
        this.isotopeGallery.arrange({filter: '*'})
      } else {
        this.isotopeGallery.arrange({filter: `.${filterTerm}`})
      }

      this.$categoryFilterTriggers.removeClass('active')
      $element.addClass('active')
    })
  }

  initIsotope () {
    this.isotopeGallery = new Isotope(this.$galleryContainer[0], {
      itemSelector: '.grid-item',
      filter: `.${window.firstFilterTerm}`
    });

    this.isotopeGallery.on('imagesLoaded', () => {
      isotopeGallery.layout()
    })
  }
}
  
export default gallery


// WEBPACK FOOTER //
// ./src/js/custom/gallery/gallery.js